export var isBigBullet = _ref => {
  var {
    state,
    customBulletContent
  } = _ref;
  return state !== 'loading' && (state && ['done', 'error', 'warning'].includes(state) || customBulletContent);
};
//# sourceMappingURL=helpers.js.map